module.exports = __webpack_public_path__ + "img/weChatEmpty.4731cc95.png";